/* eslint-disable no-mixed-spaces-and-tabs */
/**
 * 火车票正常单类
 */
export default class TrainOrder {
  constructor(order = {}) {
    this.id = order.id
    this.acceptNoSeat = order.acceptNoSeat// 是否接受无座
    this.acceptNoTotal = order.acceptNoTotal // 是否接受部分出票
    this.acceptOtherSeat = order.acceptOtherSeat // 是否接受其他坐席
    this.appDate = order.appacceptNoSeatDate // (string): 审批完成时间
    this.appId = order.appId // (string): 审批规则ID ,
    this.appUser = order.appUser // (string): 最后审批人 ,
    this.bookDate = order.bookDate // (string): 预定时间
    this.bookDeptName = order.bookDeptName // (string): 预订部门 ,
    this.bookerName = order.bookerName // (string): 预订人姓名； ,
    this.bxPrice = order.bxPrice // (number): 保险总价
    this.ccsqdId = order.ccsqdId // (string): 出差申请单ID
    this.ccsqdNo = order.ccsqdNo // (string): 出差申请单号 ,
    this.ccsqdRemark = order.ccsqdRemark // (string, optional): 出差申请单备注
    this.changeStatus = order.changeStatus // (string, optional): 改签状态 ,
    this.changeStatusDesc = order.changeStatusDesc // (string, optional): 改签状态描述 ,
    this.closeTime = order.closeTime // (string): 抢票截止时间（yyyy-MM-dd HH:mm:ss） 建议为发车时间前两小时以上 ,
    this.corpCode = order.corpCode // (string): 企业代号
    this.corpId = order.corpId // (string): 企业ID
    this.corpName = order.corpName // (string): 企业名称 ,
    this.costCenterCode = order.costCenterCode // (string): 成本中心代码
    this.costCenterId = order.costCenterId // (string): 成本中心id
    this.costCenterName = order.costCenterName // (string): 成本中心名称
    this.drawDate = order.drawDate // (string): 出票时间
    this.drawDeptName = order.drawDeptName // (string): 出票部门名称
    this.drawerName = order.drawerName // (string): 出票人名称
    this.errMsg = order.errMsg // (string): 拒单原因
    this.fromCityName = order.fromCityName // (string): 出发城市名称
    this.fromDate = order.fromDate // (string): 出发日期
    this.fromStationCode = order.fromStationCode // (string): 出发站三字码
    this.fromStationName = order.fromStationName // (string): 出发站名称
    this.fromTime = order.fromTime // (string): 出发时刻
    this.fromWeek = order.fromWeek // (string): 出发星期
    this.ifSameOrder = order.ifSameOrder // (string, optional): 订单是否一致 DY DN
    this.isNoseat = order.isNoseat // (string): 是否无座
    this.isShowChange = order.isShowChange // (string, optional): 是否显改签按钮
    this.isShowCancel = order.isShowCancel // (string, optional): 是否显取消按钮
    this.isShowPay = order.isShowPay // (string): 是否显示支付按钮
    this.isShowRefund = order.isShowRefund // (string, optional): 是否显退票按钮
    this.isShowSs = order.isShowSs // (string): 是否显示送审按钮
    this.ischange = order.ischange // (integer, optional): 改签标识1正常2部分改3全改
    this.isrefund = order.isrefund // (integer, optional): 退票标识1正常2部分退3全退
    this.linkEmail = order.linkEmail // (string): 联系人邮箱
    this.linkMobile = order.linkMobile // (string): 联系手机
    this.linkTel = order.linkTel // (string): 联系电话
    this.linkman = order.linkman // (string): 联系人
    this.orderNo = order.orderNo // (string): 订单编号
    this.orderStatus = order.orderStatus // (string): 订单状态1等待订座2已订座3等待出票4已出票5出票失败6客户消7系统消8拒单9已完成 10客户取消中11系统取消中 12 取消失败
    this.orderStatusDesc = order.orderStatusDesc // (string): 订单状态中文描述
    this.passengerNames = order.passengerNames // (string): 乘客名称
    this.payUserName = order.payUserName // (string): 支付人名称
    this.payDeptName = order.payDeptName // (string): 支付部门名称
    this.payMothedName = order.payMothedName // (string): 付款方式名称
    this.payStatus = order.payStatus // (integer): 付款状态（收款）
    this.paySubjectName = order.paySubjectName // (string): 支付科目名称
    this.payUserName = order.payUserName // (string): 支付人名称
    this.pmsOrderNo = order.pmsOrderNo // (string): 供应商订单号
    this.projectCode = order.projectCode // (string): 出差项目代码
    this.projectId = order.projectId // (string): 出差项目ID
    this.projectName = order.projectName // (string): 出差项目名称
    this.reasonCode = order.reasonCode // (string): 违背原因代码
    this.reasonDesc = order.reasonDesc // (string): 违背原因说明
    this.refundAmount = order.refundAmount // (number): 退款金额
    this.refundStatus = order.refundStatus // (string, optional): 退票状态
    this.refundStatusDesc = order.refundStatusDesc // (string, optional): 退票状态描述
    this.refundType = order.refundType // (string): 是否全额 0:差价;1:全额
    this.sellServiceCharge = order.sellServiceCharge // (number): 服务费
    this.sentDeptName = order.sentDeptName // (string, optional): 送审人所在的部门
    this.sentEmpNo = order.sentEmpNo // (string, optional): 送审人编号/名称
    this.sentTime = order.sentTime // (string, optional): 送审时间
    this.subjectCode = order.subjectCode // (string, optional): 科目码
    this.supplierName = order.supplierName // (string): 供应商名称
    this.takeTicketCode = order.takeTicketCode // (string): 取票单号
    this.ticketPrice = order.ticketPrice // (number): 票价总价
    this.toCityName = order.toCityName // (string): 到达城市名称
    this.toDate = order.toDate // (string): 到达日期
    this.toStationCode = order.toStationCode // (string): 到达站三字码
    this.toStationName = order.toStationName // (string): 到达站名称
    this.toTime = order.toTime // (string): 到达时刻
    this.trOrderId = order.trOrderId // (string): 原订单id
    this.trainCode = order.trainCode // (string): 车次
    this.trainNo = order.trainNo // (string): 列车编号
    this.travelTime = order.travelTime // (integer): 出发时刻
    this.travelTimeStr = order.travelTimeStr // (integer): 运行时长中文
    this.tripType = order.tripType // (integer): 1因公2因私
    this.violateitem = order.violateitem // (string): 违背事项说明
    this.violateitemCode = order.violateitemCode // (string): 违背事项代码
    this.vipStatus = order.vipStatus // (string): 差旅状态(审批状态)
    this.week = order.week // (string, optional)
    this.isByidcard = order.isByidcard // (string) 是否可凭二代身份证直接进出站
    this.psgList = order.psgList ? order.psgList.map(psg => new Passenger(psg, order)) : [] // (Array[ObtTrPsg]): 乘机人列表
    this.latePaymentTime = order.latePaymentTime // (string, optional) 最后支付时间 年-月-日 时:分:秒
    this.trainAccount = order.trainAccount
    this.password = order.password
    this.isShowCancelApproval = order.isShowCancelApproval
    this.seatName = order.seatName
    this.productType = order.productType //1pms 接口订单 2自有订单 3线下预订(现金票) 4线上代购(电子票退改无忧) 5商旅票

    // 补充不足的字段
    this.orderType = $dict.ORDER_TYPE.tr.normal // (string, optional) 产品类型
    this.adultCount = order.psgList && order.psgList.reduce((sum, psg) => {
      return psg.passengerType === '1' ? sum + 1 : sum
    }, 0)
    this.childCount = order.psgList && order.psgList.reduce((sum, psg) => {
      return psg.passengerType === '2' ? sum + 1 : sum
    }, 0)
  }

  // 在完成页中 是否需要一直查询
  get isLoop () {
    return this.orderStatus === '1' || this.orderStatus === '3'
  }

  // 是否是拒单
  get isReject () {
    return this.orderStatus === '7' && this.errMsg
  }

  // 支付方式
  get payMethodDesc () {
    if (this.payStatus === '1' && this.paySubjectName) {
      return `已使用${this.paySubjectName}支付`
    } else {
      return ''
    }
  }

  // 详细的订单描述
  get orderStatusDescDetail () {
    if (this.isLoop) {
      if (this.isShowSs === '1') {
        return '正在为您占座中，您可先操作送审'
      } else if (this.orderStatus === '3' && !this.trainAccount) {
        return '订单已提交，等待服务商办理操作。'
      } else {
        return '正在为您排队，加急处理中。。。'
      }
    } else if ((this.orderStatus === '2' || this.orderStatus === '4') && this.isShowPay === '1') {
      if (this.latePaymentTime) {
        return `超时未支付订单将取消，请在${this.lastPayTime.minute}分钟${this.lastPayTime.second}秒内完成支付~`
      } else {
        return '请尽快支付。'
      }
    } else if (this.orderStatus === '7') {
      return '乘客信息核验失败'
    } else {
      return ''
    }
  }

  // 因公因私描述
  get tripTypeStr () {
    return this.tripType === 1 ? '公' : '私'
  }

  // 展示审批规则
  get showApprovalRule () {
    return this.vipStatus !== '4'
  }

  // 总金额
  get totalAmount () {
    return Number(this.ticketPrice) + Number(this.sellServiceCharge) + this.bxPrice
  }

  // 距离最后支付时间
  get lastPayTime () {
    return getLastTime(this.latePaymentTime)
  }

}

/**
 * 火车票正常 退 改 订单上乘车人类
 */
export class Passenger {
  PSG_TYPE = [
  	{ key: '1', name: '成人' },
  	{ key: '2', name: '儿童' }
  ]

  CARD_TYPE = [
  	{ key: '1', name: '身份证', row: 'idNumber' },
  	{ key: 'B', name: '护照', row: 'passport', periodRow: 'passportPeriod' },
  	{ key: 'C', name: '港澳居民来往内地通行证', row: 'otherNumber', periodRow: 'otherPeriod' },
  	{ key: 'G', name: '台湾居民来往大陆通行证', row: 'otherNumber', periodRow: 'otherPeriod' },
  	{ key: 'H', name: '外国人永久居留身份证', row: 'otherNumber', periodRow: 'otherPeriod' },
  	{ key: '2', name: '港澳台居民居住证', row: 'otherNumber', periodRow: 'otherPeriod' }
  ]

  /**
   * @param {Object} psg
   * @param {TrainOrder} order 火车票订单信息
   */
  constructor(psg = {}, order) {
  	this.id = psg.id // (string, optional): 票号表id ,
  	this.psgId = psg.psgId // (string): 乘车人id
  	this.empId = psg.empId // (string): 员工id ,
  	this.sex = psg.sex // (string): M男 F女
  	this.fsEmpDeptId = psg.fsEmpDeptId // (string): 附属员工部门id ,
  	this.fsEmpId = psg.fsEmpId // (string): 附属员工id ,
  	this.fsEmpName = psg.fsEmpName // (string): 附属员工名称 ,
  	this.fsEmpNo = psg.fsEmpNo // (string): 附属员工工号 ,
  	this.idCode = psg.idCode // (string): 证件号码 ,
  	this.idType = psg.idType // (string): 证件类型1:二代身份证:一代身份证C:港澳通行证G:台湾通行证B:护照 ,
  	this.passengerName = psg.passengerName // (string): 姓名 ,
  	this.passengerType = psg.passengerType || '1' // (string): 乘车人类型1、成人；2儿童 ,
  	this.seatCode = psg.seatCode || psg.newSeatCode // (string): 座位号 ,
  	this.seatType = psg.seatType // (string): 席别；9:商务座P:特等座M:一等座O:二等座/无座6:高级软卧4:软卧3:硬卧2:软座1:硬座/无座
  	this.sellServiceCharge = psg.sellServiceCharge || psg.buyServiceCharge || 0 // (number): 销售服务费 ,
  	this.ticketCode = psg.ticketCode // (string): 票号
  	this.ticketPrice = psg.ticketPrice || psg.newTicketPrice // (number): 票价
  	this.ticketType = psg.ticketType // (string): 票种1成人票2儿童票3学生票4残军票
  	this.refundStatus = psg.refundStatus // (string, optional): 退票状态
  	this.changeStatus = psg.changeStatus // (string, optional): 改签状态
  	this.phoneNumber = psg.phoneNumber // (string, optional): 手机号
  	this.isReturn = psg.isReturn // (string, optional) 是否可退 1可退 0和其他不可退
  	this.isChange = psg.isChange // 是否改签0未改签1已改签2改签中 ,
  	this.isTicket = psg.isTicket // (string): 是否出票0未出票1已出票

  	this.seatTypeName = psg.seatTypeName || order.seatTypeName || order.newSeatTypeName // (string): 席别名称
  }

  get idTypeName () {
  	return this.CARD_TYPE.find(type => type.key == this.idType).name
  }

  get passengerTypeName () {
  	return this.PSG_TYPE.find(type => type.key == this.passengerType).name
  }

  get ticketTypeName () {
  	return `${this.passengerTypeName}票`
  }

  // 展示 "已申请退票" 标记
  get showRefundTag () {
  	if (this.refundStatus) {
  		return this.refundStatus === '1'
  	} else {
  		return this.isReturn !== '0'
  	}
  }

  // 展示 "已申请改签" 标记
  get showChangeTag () {
  	if (this.changeStatus) {
  		return this.changeStatus === '1'
  	} else {
  		return this.isChange !== '0'
  	}
  }

  // 不可申请退票
  get abledRefund () {
  	if (this.passengerType === '1') {
  		if (this.psgId) {
  			return this.isChange === '0' && this.isReturn === '0' && this.isTicket === '1'
  		} else {
  			return this.isReturn === '1'
  		}
  	} else {
  		return false
  	}
  }

  get ticketPriceStr () {
  	return '￥' + this.ticketPrice
  }

  get sellServiceChargeStr () {
  	return '￥' + this.sellServiceCharge
  }

}

function getLastTime (endTime) {
  endTime = endTime.replace(/-/g, '/')
  let date = new Date(),
	  now = date * 1,
	  end = new Date(endTime) * 1 // 结束时间

  let lefttime = end - now

  let day, hour, minute, second

  if (lefttime > 0) {
    day = Math.floor(lefttime / 1000 / 60 / 60 / 24)
    hour = Math.floor(Math.floor(lefttime / 1000 / 60 / 60 / 24) * 24 + (lefttime / 1000 / 60 / 60 % 24))
    minute = Math.floor(lefttime / 1000 / 60 % 60)
    second = Math.floor(lefttime / 1000 % 60)

    if (second < 10) {
      second = '0' + second
    }

    if (minute < 10) {
      minute = '0' + minute
    }

    if (hour < 10) {
      hour = '0' + hour
    }
  }
  return { day, hour, minute, second }
}

